import { render } from "./OpenNewWindow.vue?vue&type=template&id=0f48eed2"
import script from "./OpenNewWindow.vue?vue&type=script&lang=js"
export * from "./OpenNewWindow.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__